// Centralized API calls for the Case Review feature. Uses the shared ApiClient
// (axios) so auth headers, token refresh and 401 handling are consistent with
// the rest of the app — no hand-rolled JWT validation or token-in-URL.
import ApiClient from '../../utils/ApiClient';

export function fetchCases() {
    return ApiClient.get('/api/qrcases').then((r) => r.data);
}

export function fetchCaseDetails(caseId) {
    return ApiClient.get(`/api/qrcases/${caseId}`).then((r) => r.data);
}

export function fetchEmailTemplates() {
    return ApiClient.get('/api/case-templates').then((r) => r.data);
}

export function updateCaseStatus(caseId, status) {
    return ApiClient.post(`/api/qrcases/${caseId}/status`, { status }).then((r) => r.data);
}

export function saveAmazonCaseData(caseId, payload) {
    return ApiClient.post(`/api/qrcases/${caseId}/amazon-data`, payload).then((r) => r.data);
}

// Mint a short-lived, server-issued token for the phone-upload QR code so the
// long-lived session JWT is never encoded into the QR image.
export function createUploadToken(caseId) {
    return ApiClient.post(`/api/qrcases/${caseId}/upload-token`).then((r) => r.data);
}

export function uploadPhotos(formData) {
    // Let axios set the multipart boundary itself by overriding the default
    // application/json content-type.
    return ApiClient.post('/api/returns/createcase/uploadphotos', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    }).then((r) => r.data);
}

// Fetch a photo (or its thumbnail) as a Blob via ApiClient so the Authorization
// header is used instead of putting the JWT in the image URL.
export function fetchPhotoBlob(caseId, section, filename, { thumb = false } = {}) {
    const url = `/uploads/returns/${caseId}/${section}/${filename}${thumb ? '?size=thumb' : ''}`;
    return ApiClient.get(url, { responseType: 'blob' }).then((r) => r.data);
}
